import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BranchContext = createContext(null);

export function BranchProvider({ children }) {
  const { user } = useAuth();
  const [branches, setBranches] = useState([]);
  const [canViewAll, setCanViewAll] = useState(true);
  const [branch, setBranchState] = useState(localStorage.getItem("hoe_branch") || "all");

  useEffect(() => {
    if (!user) return;
    api.get("/branches").then((r) => {
      const data = r.data;
      setBranches(data.branches || []);
      setCanViewAll(data.canViewAll);
      // Branch managers are locked to their branch
      if (!data.canViewAll && data.userBranch) {
        localStorage.setItem("hoe_branch", data.userBranch);
        setBranchState(data.userBranch);
      } else if (!localStorage.getItem("hoe_branch")) {
        localStorage.setItem("hoe_branch", "all");
        setBranchState("all");
      }
    }).catch(() => {});
  }, [user]);

  const setBranch = (code) => {
    localStorage.setItem("hoe_branch", code);
    // Reload so every page re-fetches scoped to the new branch
    window.location.reload();
  };

  const currentBranchLabel =
    branch === "all" ? "All Branches" : (branches.find((b) => b.code === branch)?.name || branch);
  const currentPrefix =
    branch === "all" ? "" : (branches.find((b) => b.code === branch)?.prefix || branch);

  const value = useMemo(
    () => ({ branch, setBranch, branches, canViewAll, currentBranchLabel, currentPrefix }),
    [branch, branches, canViewAll, currentBranchLabel, currentPrefix]
  );

  return (
    <BranchContext.Provider value={value}>
      {children}
    </BranchContext.Provider>
  );
}

export function useBranch() {
  return useContext(BranchContext);
}
